import React from "react";
import { Button, Form, Input, Modal } from "antd";
import { LockOutlined } from "@ant-design/icons";
import {
  ActivitySection,
  ActvtySecTitle,
  ActvtySecWrapper,
  Container,
  InfoSection,
  InfoSectionFig,
  InfoSectionImg,
  Title,
  TitleHead,
  TitleInfo,
} from "../../Styles";
import image from "../../assets/images/reset-pass.svg";
import "../../Styles.css";
import fire from "../../fire";
import { useHistory } from "react-router-dom";

function ResetPass(props: any) {
  const history = useHistory();

  const onFinish = (values: any) => {
    // console.log("Received values of form: ", values);
    const params = new URLSearchParams(window.location.search);
    var actionCode: any = params.get("oobCode");
    // console.log(actionCode);
    fire
      .auth()
      .verifyPasswordResetCode(actionCode)
      .then((email: any) => {
        // var accountEmail = email;
        var newPassword = values.password;
        fire
          .auth()
          .confirmPasswordReset(actionCode, newPassword)
          .then((resp) => {
            function countDown() {
              let secondsToGo = 2;
              const modal = Modal.success({
                title: `Password Updated Succesfully!!!`,
              });
              const timer = setInterval(() => {
                secondsToGo -= 1;
              }, 1000);
              setTimeout(() => {
                clearInterval(timer);
                modal.destroy();
                history.push("/");
              }, secondsToGo * 1000);
            }
            countDown();
          })
          .catch((error) => {
            // console.log(error.code, error.message);
          });
      })
      .catch((error) => {
        // console.log(error.code, error.message);
      });
  };

  return (
    <Container>
      <InfoSection>
        <InfoSectionFig>
          {" "}
          <InfoSectionImg src={image} />
        </InfoSectionFig>
        <Title>
          <TitleHead>Some title goes here</TitleHead>
          <TitleInfo>
            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
            sint. Velit officia consequat duis enim velit mollit. Exercitation
            veniam consequat sunt nostrud amet.
          </TitleInfo>
        </Title>
      </InfoSection>
      <ActivitySection>
        <ActvtySecWrapper>
          <ActvtySecTitle>Reset Password</ActvtySecTitle>
          <Form
            name="register"
            onFinish={onFinish}
            initialValues={{}}
            scrollToFirstError
          >
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please Enter Your Password!",
                },
                {
                  pattern:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/g,
                  message: "Password must contain atleast 8 characters",
                },
                {
                  pattern: /[0-9]{1,}/g,
                  message: "Password must contain atleast 1 number",
                },
                {
                  pattern: /[A-Z]{1,}/g,
                  message:
                    "Password must contain atleast 1 letter in capital case",
                },
                {
                  pattern: /[a-z]{1,}/g,
                  message:
                    "Password must contain atleast 1 letter in small case",
                },
                {
                  pattern: /[^A-Z0-9a-z]{1,}/g,
                  message: "Must contain atleast 1 special character",
                },
              ]}
              hasFeedback
            >
              <Input.Password
                style={{ fontFamily: "Montserrat" }}
                prefix={<LockOutlined className="site-form-item-icon" />}
                placeholder="Password"
              />
            </Form.Item>
            <Form.Item
              name="confirm"
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please Confirm Your Password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }

                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                style={{ fontFamily: "Montserrat" }}
                prefix={<LockOutlined className="site-form-item-icon" />}
                placeholder="Comfirm Password"
              />
            </Form.Item>
            <Form.Item>
              <Button className="loginButton" type="primary" htmlType="submit">
                Reset Password
              </Button>
            </Form.Item>
          </Form>
        </ActvtySecWrapper>
      </ActivitySection>
    </Container>
  );
}

export default ResetPass;
